import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Container, Paper, TextField, Typography } from '@mui/material';
import axios from 'axios';
import CustomAlert from '../../components/ConfirmationModal/CustomAlert';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';

const schema = yup.object({
    password: yup.string()
        .required('პაროლი სავალდებულოა')
        .min(6, 'პაროლი უნდა შეიცავდეს მინიმუმ 6 სიმბოლოს')
        .matches(/[a-z]/, 'პაროლში უნდა იყოს მინიმუმ ერთი პატარა ასო')
        .matches(/[A-Z]/, 'პაროლში უნდა იყოს მინიმუმ ერთი დიდი ასო')
        .matches(/\d/, 'პაროლი უნდა შეიცავდეს ციფრს'),
    repeatPassword: yup.string()
        .oneOf([yup.ref('password'), null], 'პაროლები უნდა ემთხვეოდეს')
});

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const ResetPassword = () => {
    const { control, handleSubmit, setValue, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });
    const query = useQuery();
    const employeeId = query.get('param1');
    const secretPass = query.get('param2');

    const [showPassword, setShowPassword] = useState(false);
    const [showRepeatPassword, setShowRepeatPassword] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ message: '', type: '', open: false });
    const navigate = useNavigate();

    const onSubmit = async (data) => {
        const payload = {
            confirmationId: secretPass,
            userId: employeeId,
            password: data.password,
            repeatPassword: data.repeatPassword
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/User/ResetPassword`, payload);

            if (response.data.success) {
                setAlertInfo({ message: 'პაროლი წამრატებით განახლდა', type: 'success', open: true });
                setTimeout(() => navigate('/'), 500);
            } else {
                setAlertInfo({ message: response.data.errorMessage || 'დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით', type: 'error', open: true });
            }
        } catch (error) {
            setAlertInfo({ message: 'დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით', type: 'error', open: true });
        }
    };

    const closeAlert = () => setAlertInfo({ ...alertInfo, open: false });

    const handleChangeWithoutSpaces = (fieldName, value) => {
        // Remove all spaces from the input value
        const newValue = value.replace(/\s/g, '');
        setValue(fieldName, newValue); // Update the form field
    };

    return (
        <Container style={{ minHeight: '70vh' }} component="main" maxWidth="xs">
            <Paper style={{ padding: 20, marginTop: 100 }}>
                <Typography component="h1" variant="h5">პაროლის აღდგენა</Typography>
                <form onSubmit={handleSubmit(onSubmit)} noValidate>
                    <Controller
                        name="password"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                            <TextField
                                {...field}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                label="ახალი პაროლი"
                                type={showPassword ? 'text' : 'password'}
                                error={!!errors.password}
                                helperText={errors.password?.message}
                                onChange={(e) => handleChangeWithoutSpaces('password', e.target.value)}
                                InputProps={{
                                    endAdornment: (
                                        <Button onClick={() => setShowPassword(!showPassword)}>
                                            {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                                        </Button>
                                    ),
                                }}
                            />
                        )}
                    />
                    <Controller
                        name="repeatPassword"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                            <TextField
                                {...field}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                label="გაიმეორეთ პაროლი"
                                type={showRepeatPassword ? 'text' : 'password'}
                                error={!!errors.repeatPassword}
                                helperText={errors.repeatPassword?.message}
                                onChange={(e) => handleChangeWithoutSpaces('repeatPassword', e.target.value)}
                                InputProps={{
                                    endAdornment: (
                                        <Button onClick={() => setShowRepeatPassword(!showRepeatPassword)}>
                                            {showRepeatPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                                        </Button>
                                    ),
                                }}
                            />
                        )}
                    />
                    <Button type="submit" fullWidth variant="contained" color="primary" style={{ margin: '20px 0' }}>
                        პაროლის შეცვლა
                    </Button>
                </form>
            </Paper>
            {alertInfo.open && (
                <CustomAlert message={alertInfo.message} type={alertInfo.type} onClose={closeAlert} />
            )}
        </Container>
    );
};

export default ResetPassword;
